// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <defs>
                <polygon id="a" points="0 0 20 0 20 20 0 20" />
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(-.001)">
                <mask id="b" fill="currentColor">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    fill="currentColor"
                    d="M14.4330373,14.9818941 L6.84828082,4.95047265 L5.5844722,4.95047265 L13.2539905,14.9818941 L14.4282754,14.9818941 L14.4330373,14.9818941 Z M16.1206552,3.74952113 L11.4863727,9.04475544 L16.9377974,16.2495211 L12.669229,16.2495211 L9.33018381,11.8790391 L5.50447226,16.2495211 L3.38352139,16.2495211 L8.33970833,10.5847543 L3.11114063,3.74952113 L7.4863756,3.74952113 L10.5092306,7.74570875 L13.9997043,3.74952113 L16.1206552,3.74952113 Z M2.8568551,0 C1.28161813,0 -0.000285714082,1.28095147 -0.000285714082,2.85714082 L-0.000285714082,17.1428449 C-0.000285714082,18.7180819 1.28161813,19.9999857 2.8568551,19.9999857 L17.1425592,19.9999857 C18.7187485,19.9999857 19.9997,18.7180819 19.9997,17.1428449 L19.9997,2.85714082 C19.9997,1.28095147 18.7187485,0 17.1425592,0 L2.8568551,0 Z"
                    mask="url(#b)"
                />
            </g>
        </svg>
    );
};

export default React.memo(Twitter);
